<template>
  <div class="container">
    <b-alert class="border border-dark w-100 my-4" show variant="danger">
      <h4 class="alert-heading">
        {{ getContentItem("error") }}
      </h4>
      <div class="my-4">
        <p>{{ getContentItem("ProblemSendingEmail") }}</p>
        <p v-if="errorMessage">
          {{ errorMessage }}
        </p>
      </div>
      <div class="call-for-support">
        <p>{{ getContentItem("PleaseContactUs") }}</p>
        <p class="d-flex align-items-center">
          <font-awesome-icon :icon="phoneIcon" size="2x" class="mr-2" />
          {{ tenantDetails.SupportPhoneNumber }}
        </p>
      </div>
    </b-alert>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { stringHelper } from "@/components/mixins/stringHelper";

  import { faPhoneSquareAlt } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

  export default {
    name: "SendError",
    components: {
      FontAwesomeIcon
    },
    mixins: [stringHelper],
    props: {
      errorMessage: {
        type: String,
        default: ""
      },
    },
    data: () => ({
      phoneIcon: faPhoneSquareAlt,
    }),
    computed: {
      ...mapGetters(["getContentItem", "tenantDetails"]),
    },
  };
</script>
